import React, { useState, useContext } from "react";
import "./BuildDreamExterior.css";
import { LanguageContext } from "../../context/LanguageContext";

import CarStarNightBlack from "../../assets/images/buildDream/blackCar.webp";
import CarSnowWhite from "../../assets/images/buildDream/whiteCar.webp";
import CarMidnightViolet from "../../assets/images/buildDream/violetCar.webp";

import ThumbStarNightBlack from "../../assets/images/buildDream/blackColor.webp";
import ThumbSnowWhite from "../../assets/images/buildDream/whiteColor.webp";
import ThumbMidnightViolet from "../../assets/images/buildDream/violetColor.webp";

const COLORS = [
  {
    id: 1,
    name: "Star Night Black",
    carImg: CarStarNightBlack,
    thumb: ThumbStarNightBlack,
  },
  {
    id: 2,
    name: "Snow White",
    carImg: CarSnowWhite,
    thumb: ThumbSnowWhite,
  },
  {
    id: 3,
    name: "Midnight Violet",
    carImg: CarMidnightViolet,
    thumb: ThumbMidnightViolet,
  },
];

const BuildDreamExterior = ({ onSelect }) => {
  const { texts } = useContext(LanguageContext);
  const t = texts.buildDream || {};
  const exteriorLabels = t.exteriors || {};

  const [selected, setSelected] = useState(COLORS[0]);

  const handleSelect = (c) => {
    setSelected(c);
    onSelect && onSelect(c);
  };

  return (
    <div className="dream-exterior">
      <div className="dream-top">
        <h1 className="dream-title">{t.buildYourCar}</h1>
        <h2 className="dream-model">{t.modelName}</h2>
        <h4 className="dream-choose-title">{t.chooseExterior}</h4>
      </div>

      <div className="dream-main">
        <div className="dream-car-display">
          <img
            src={selected.carImg}
            className="dream-car-img"
            alt={exteriorLabels[selected.name] || selected.name}
          />
        </div>

        <div className="dream-color-list">
          {COLORS.map((c) => (
            <div
              key={c.id}
              className={`dream-color-item ${selected.id === c.id ? "active" : ""}`}
              onClick={() => handleSelect(c)}
            >
              <div className="dream-thumb-wrapper">
                <img
                  src={c.thumb}
                  alt={exteriorLabels[c.name] || c.name}
                  className="dream-color-thumb"
                />
              </div>
              <p className="dream-color-name">{exteriorLabels[c.name] || c.name}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BuildDreamExterior;
